
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 524 469.8","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M514.8 239.2L268.8 8.7c-3.9-3.6-9.8-3.6-13.7 0L9.2 239.2c-4 3.8-4.2 10.1-.5 14.2 1.9 2 4.5 3.2 7.3 3.2h59.9v197.3c0 5.5 4.5 10 10 10H438c5.5 0 10-4.5 10-10V256.5h60c5.5 0 10-4.5 10-10 0-2.8-1.1-5.4-3.2-7.3zM343 443.8H181V256.7h162v187.1zm95.1-207.3c-5.5 0-10 4.5-10 10v197.3h-65V246.7c0-5.5-4.5-10-10-10H171c-5.5 0-10 4.5-10 10v197.1H96V246.5c0-5.5-4.5-10-10-10H41.3L262 29.7l220.7 206.7h-44.6z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M352.3 148.9l-53.2-50.2c-4-3.8-10.4-3.6-14.2.4-3.8 4-3.6 10.4.4 14.2l53.2 50.2c1.9 1.8 4.3 2.7 6.9 2.7 2.8 0 5.4-1.1 7.3-3.1 3.8-4 3.6-10.4-.4-14.2zm20.7 23.3c-12.9 0-12.9 20 0 20 12.9.1 12.9-20 0-20z"}})])
          )
        }
      }
    